import { defineStyle, defineStyleConfig } from '@chakra-ui/styled-system'

const baseStyle = defineStyle({
  opacity: 1.0,
})

export default defineStyleConfig({
  baseStyle,
})
